$.fn.warningPage = function () {
  function isInWarningPage() {
    return $("#warning-page").length > 0;
  }

  function isInInstancePage() {
    return $("#instance-page").length > 0;
  }

  function isInDatasetPage() {
    return $("#dataset").length > 0;
  }

  function isInLedgerPage() {
    return $("#ledgerTable").length > 0;
  }

  function isInPaymentTable() {
    return $("#paymentTable").length > 0;
  }

  function isInAssociateOrgsPage() {
    return $("#associateOrganisations").length > 0;
  }

  if (isInWarningPage()) {
    var count = 0;

    $("#saved-records").on("change", function () {
      if ($(this).prop("checked") == true) {
        $(':input[type="submit"]').prop("disabled", false);
        count++;
      } else {
        count--;
        if (count == 0) {
          $(':input[type="submit"]').prop("disabled", true);
        }
      }
    });

    $("#certified-records").on("change", function () {
      if ($(this).prop("checked") == true) {
        count++;
        $(':input[type="submit"]').prop("disabled", false);
      } else {
        count--;
        if (count == 0) {
          $(':input[type="submit"]').prop("disabled", true);
        }
      }
    });

    $("#submitted-records").on("change", function () {
      if ($(this).prop("checked") == true) {
        $(':input[type="submit"]').prop("disabled", false);
        count++;
      } else {
        count--;
        if (count == 0) {
          $(':input[type="submit"]').prop("disabled", true);
        }
      }
    });
  }

  if (isInInstancePage()) {
    var enableNotifications = $("#enable-notifications").val();
    $("#disable-notifications").on("change", function () {
      if ($(this).prop("checked") == true) {
        $("#enable-notifications").val(false);
      } else {
        $("#enable-notifications").val(true);
      }
    });
    $("#allowNonFinancialDataCertifierToCertify").on("change", function () {
      if ($(this).is(":checked")) {
        $("#allowNonFinancialDataCertifierToCertify").val(true);
      } else {
        $("#allowNonFinancialDataCertifierToCertify").val(false);
      }
    });
    var datasetType = $("#dataset-type").val();
    var instanceType = $("#collectionType").val();
    if (
      datasetType.includes("stats") &&
      instanceType == "DATA_COLLECTION_AND_CERTIFY"
    ) {
      $("#allowNonFinancialDataCertifierToCertify")
        .closest(".govuk-form-group")
        .removeAttr("hidden");
      $("#allowDataCertifierToCertify")
        .closest(".govuk-form-group")
        .removeAttr("hidden");
    } else {
      $("#allowNonFinancialDataCertifierToCertify")
        .closest(".govuk-form-group")
        .attr("hidden", "hidden");
      $("#allowDataCertifierToCertify")
        .closest(".govuk-form-group")
        .attr("hidden", "hidden");
    }

    if (instanceType != "PRE_AUDIT") {
      $("#auditSubmissionDeadlineDate")
        .closest(".govuk-form-group")
        .attr("hidden", "hidden");
      $("#auditthreshold")
        .closest(".govuk-form-group")
        .attr("hidden", "hidden");
    } else {
      $("#auditSubmissionDeadlineDate")
        .closest(".govuk-form-group")
        .removeAttr("hidden");
      $("#auditthreshold").closest(".govuk-form-group").removeAttr("hidden");
    }

    if (instanceType != "SELF_CERTIFY_MANUAL_APPROVAL") {
      $("#billing-attachments")
        .closest(".govuk-form-group")
        .attr("hidden", "hidden");
    } else {
      $("#billing-attachments")
        .closest(".govuk-form-group")
        .removeAttr("hidden");
    }

    if (instanceType == "DATA_COLLECTION") {
      $("#certificationText")
        .closest(".govuk-form-group")
        .attr("hidden", "hidden");
    } else {
      $("#certificationText").closest(".govuk-form-group").removeAttr("hidden");
    }

    $("#collectionType").on("change", function () {
      //            console.log($(this).text());
      if (
        datasetType.includes("stats") &&
        $(this).val() == "DATA_COLLECTION_AND_CERTIFY"
      ) {
        $("#allowNonFinancialDataCertifierToCertify")
          .closest(".govuk-form-group")
          .removeAttr("hidden");
        $("#allowDataCertifierToCertify")
          .closest(".govuk-form-group")
          .removeAttr("hidden");
      } else {
        $("#allowNonFinancialDataCertifierToCertify")
          .closest(".govuk-form-group")
          .attr("hidden", "hidden");
        $("#allowDataCertifierToCertify")
          .closest(".govuk-form-group")
          .attr("hidden", "hidden");
      }
      if ($(this).val() != "PRE_AUDIT") {
        $("#auditSubmissionDeadlineDate")
          .closest(".govuk-form-group")
          .attr("hidden", "hidden");
        $("#auditthreshold")
          .closest(".govuk-form-group")
          .attr("hidden", "hidden");
      } else {
        $("#auditSubmissionDeadlineDate")
          .closest(".govuk-form-group")
          .removeAttr("hidden");
        $("#auditthreshold").closest(".govuk-form-group").removeAttr("hidden");
      }
      if ($(this).val() != "SELF_CERTIFY_MANUAL_APPROVAL") {
        $("#billing-attachments")
          .closest(".govuk-form-group")
          .attr("hidden", "hidden");
      } else {
        $("#billing-attachments")
          .closest(".govuk-form-group")
          .removeAttr("hidden");
      }
      if ($(this).val() == "DATA_COLLECTION") {
        $("#certificationText")
          .closest(".govuk-form-group")
          .attr("hidden", "hidden");
      } else {
        $("#certificationText")
          .closest(".govuk-form-group")
          .removeAttr("hidden");
      }
    });
  }

  if (isInDatasetPage()) {
    $("#contains-sensitive-data").on("click", function () {
      if ($(this).prop("checked") == true) {
        $("#restrict-providers").removeAttr("hidden");
      }
    });
    $("#doesnot-contain-sensitive-data").on("click", function () {
      if ($(this).prop("checked") == true) {
        $("#restrict-providers").attr("hidden", "hidden");
      }
    });
    if ($("#contains-sensitive-data").prop("checked") == true) {
      $("#restrict-providers").removeAttr("hidden");
    }
  }

  if (isInPaymentTable()) {
    $(".remove-btn").click(function () {
      $(this).closest("tr").remove();
    });
    if ($("#organisationSpecific").is(":checked")) {
      $("#profileId").closest(".govuk-form-group").removeAttr("hidden");
    } else {
      $("#profileId").closest(".govuk-form-group").attr("hidden", "hidden");
    }
    $("#organisationSpecific").on("change", function () {
      if ($(this).is(":checked")) {
        $("#profileId").closest(".govuk-form-group").removeAttr("hidden");
      }
    });

    $("#default").on("change", function () {
      if ($(this).is(":checked")) {
        $("#profileId").closest(".govuk-form-group").attr("hidden", "hidden");
      }
    });

    $("#beforePayment").on("change", function () {
      if ($(this).is(":checked")) {
        updateReceiptDate(-7);
      }
    });
    $("#afterPayment").on("change", function () {
      if ($(this).is(":checked")) {
        updateReceiptDate(7);
      }
    });

    $(".profilePaymentDate").on("change", function () {
      var numOfDays;
      if ($("#beforePayment").is(":checked")) {
        numOfDays = -7;
      } else if ($("#afterPayment").is(":checked")) {
        numOfDays = 7;
      } else {
        numOfDays = 0;
      }

      var starts = $(this).val();
      var match = /(\d+)\/(\d+)\/(\d+)/.exec(starts);
      var start_date = new Date(match[3], match[2] - 1, match[1]);
      start_date.setDate(start_date.getDate() + numOfDays);
      //                    start_date.setMonth(start_date.getMonth() + 1);
      var receiptDate = "";
      receiptDate =
        ("0" + start_date.getDate()).slice(-2) +
        "/" +
        ("0" + (start_date.getMonth() + 1)).slice(-2) +
        "/" +
        start_date.getFullYear();
      $(this).closest("td").next().text(receiptDate);
      var receiptList = "";
      $("table")
        .find("td:nth-child(3)")
        .each(function () {
          receiptList = receiptList + "," + $(this).text();
        });
      //                    receiptList = receiptList + ",1,8,15,22,29";
      var str = receiptList.substring(1);
      var delimiter = ",";
      var start = $("#numberOfDates").val();
      var tokens = str.split(delimiter).slice(0, start);
      var result = tokens.join(delimiter);
      $("#profileReceiptDate").val(result);
      //                    console.log(result);
    });

    function updateReceiptDate(numOfDays) {
      $("table")
        .find("td:nth-child(2)")
        .each(function () {
          var starts = $(this).find("input").val();
          var match = /(\d+)\/(\d+)\/(\d+)/.exec(starts);
          var start_date = new Date(match[3], match[2] - 1, match[1]);
          start_date.setDate(start_date.getDate() + numOfDays);
          var receiptDate = "";
          receiptDate =
            ("0" + start_date.getDate()).slice(-2) +
            "/" +
            ("0" + (start_date.getMonth() + 1)).slice(-2) +
            "/" +
            start_date.getFullYear();
          $(this).next().text(receiptDate);
        });
      var receiptList = "";
      $("table")
        .find("td:nth-child(3)")
        .each(function () {
          receiptList = receiptList + "," + $(this).text();
        });
      //                    receiptList = receiptList + ",1,8,15,22,29";
      var str = receiptList.substring(1);
      var delimiter = ",";
      var start = $("#numberOfDates").val();

      var tokens = str.split(delimiter).slice(0, start);
      var result = tokens.join(delimiter);
      $("#profileReceiptDate").val(result);
    }

  }

  if (isInAssociateOrgsPage()) {
    var baseHref = $("#addOrgs").attr("href");
    var hrefCopy = baseHref;
    var uploadHref = $("#uploadOrg").attr("href");
    var uploadHrefCopy = uploadHref;
    var downloadHref = $("#downloadOrg").attr("href");
    var downloadHrefCopy = downloadHref;

    if ($("#datasetProfile").val() != null) {
      var selectedVal = $("#datasetProfile").val();
      var splittedVals = selectedVal.split(":");
      var datasetId = splittedVals[0].split(" ")[0];
      var profileName = splittedVals[1].split(" (")[1].split(")")[0];
      hrefCopy =
        baseHref + "&datasetId=" + datasetId + "&profileName=" + profileName;
      uploadHrefCopy =
        uploadHref + "&datasetId=" + datasetId + "&profileName=" + profileName;
      downloadHrefCopy =
        downloadHref +
        "&datasetId=" +
        datasetId +
        "&profileName=" +
        profileName;
      $("#addOrgs").attr("href", hrefCopy);
      $("#uploadOrg").attr("href", uploadHrefCopy);
      $("#downloadOrg").attr("href", downloadHrefCopy);
      $(".action-list-header").removeAttr("hidden");
      //            $('#addOrgs').removeAttr('disabled');
      //            $('#uploadOrg').removeAttr('disabled');
      //            $('#downloadOrg').removeAttr('disabled');
      $("#datasetId").val(datasetId);
      $("#profileName").val(profileName);
    }

    $("#datasetProfile").on("change", function () {
      var selectedVal = $(this).val();
      var splittedVals = selectedVal.split(":");
      var datasetId = splittedVals[0].split(" ")[0];
      var profileName = splittedVals[1].split(" (")[1].split(")")[0];
      hrefCopy =
        baseHref + "&datasetId=" + datasetId + "&profileName=" + profileName;
      uploadHrefCopy =
        uploadHref + "&datasetId=" + datasetId + "&profileName=" + profileName;
      downloadHrefCopy =
        downloadHref +
        "&datasetId=" +
        datasetId +
        "&profileName=" +
        profileName;
      $("#addOrgs").attr("href", hrefCopy);
      $("#uploadOrg").attr("href", uploadHrefCopy);
      $("#downloadOrg").attr("href", downloadHrefCopy);
      //            $('#addOrgs').removeAttr('disabled');
      //            $('#uploadOrg').removeAttr('disabled');
      //            $('#downloadOrg').removeAttr('disabled');
      $(".action-list-header").removeAttr("hidden");
      $("#datasetId").val(datasetId);
      $("#profileName").val(profileName);
    });
  }
};
